export default __webpack_public_path__ + "assets/models/850e767de6fce56a2956e3dbd35657f5.glb";